import { useAppIcon, AppIconVariant } from './use-app-icons';

import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import type { IconButtonProps } from '@mui/material/IconButton';

export interface SharedIconButtonProps
  extends Omit<IconButtonProps, 'children'> {
  variant: AppIconVariant;
  tooltipLabel?: string;
  isLoading?: boolean;
  disableTooltip?: boolean;
}

export default function SharedIconButton({
  tooltipLabel,
  variant,
  isLoading = false,
  disableTooltip = false,
  ...rest
}: SharedIconButtonProps) {
  const IconComponent = useAppIcon(variant);
  const accessibleName = rest['aria-label'] || tooltipLabel;

  const buttonContent = (
    <span>
      <IconButton
        {...rest}
        aria-label={accessibleName}
        disabled={isLoading || rest.disabled}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <IconComponent />
        )}
      </IconButton>
    </span>
  );

  if (disableTooltip) {
    return buttonContent;
  }

  return (
    <Tooltip arrow title={tooltipLabel || ''}>
      {buttonContent}
    </Tooltip>
  );
}
